import React, {useEffect, useState} from 'react';
import './NewSideBar.scss';
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import {toast} from "react-toastify";
import {Link} from "react-router-dom";
import IconViewer from "../../../Assets/svg/IconViewer";
import Swal from "sweetalert2";

const NewSideBar = ({open, setOpen}) => {

  const [sideData, setSideData] = useState({
    sidebarElements: [],
    style: {},
    type: 1
  });
  const [isLoad, setIsLoad] = useState(false);
  const Arrow = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#F5F5F5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M19.92 8.95l-6.52 6.52c-.77.77-2.03.77-2.8 0L4.08 8.95"
    ></path>
  </svg>

  const Close = <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16936 15.5801C8.97936 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69936 15.3601C9.55936 15.5101 9.35936 15.5801 9.16936 15.5801Z"
      fill="#FFFFFF"
    />
    <path
      d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40936 8.35011 9.69936 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
      fill="#FFFFFF"
    />
    <path
      d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
      fill="#FFFFFF"
    />
  </svg>

  useEffect(() => {
    _axios.get(prefixUrl() + "/lx_content/").then((response) => {
      if (response.data?.status) {
        setSideData({
          sidebarElements: response?.data?.sidebarElements,
          style: response?.data?.style,
          type: response?.data?.type
        })
        setIsLoad(true)
        document.getElementById("overlay-root").classList.add(`themeType${response.data.type}`)
        document.getElementById("root").classList.add(`themeType${response.data.type}`)
      } else {
        toast.error(response?.date?.message)
      }
    })
  }, []);

  const openCloseHandler = (data, id) => {
    const subUlElement = document.getElementById(id);
    subUlElement.parentElement.classList.toggle("arrow-changer");

    if (subUlElement) {
      const currentHeight = subUlElement.style.height;

      if (currentHeight === '0px' || currentHeight === '') {
        subUlElement.style.height = `${data.length * 50}px`;
      } else {
        subUlElement.style.height = '0px';
      }
    }
  };

  function logOutHandler() {
    Swal.fire({
      title: "خروج از سامانه",
      text: `آیا مطمئنید؟`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
      }
    });
  }

  try {
    return (
      <>
        {isLoad ?
          <ul className={`new-side-bar sidebarType${sideData?.type} ${open && "RPSidebar"}`}
              style={{backgroundColor: sideData?.style?.background}}>
            {sideData?.sidebarElements?.length > 0 && sideData?.sidebarElements?.map((item, index) => (
              item?.hasSubList && item?.subList ?
                <li key={"side-" + index} className={`liIndex${index}`}>
                  <div className={"row-hasSub"}>
                    <div className={"hasSub-caption"}
                         onClick={() => openCloseHandler(item?.subList, "subList" + index)}>
                    <span style={{color: sideData?.style?.fontColor}}>
                      {item.icon && <IconViewer icon={item.icon}/>}
                      {item?.caption}
                    </span>
                      <span className={"current-arrow"}>
                      {Arrow}
                    </span>
                    </div>
                    <div id={"subList" + index} className={"sub-list"}>
                      {item?.subList.map((subItem, subIndex) => (
                        <Link key={"sub" + subIndex} to={subItem?.route}
                              state={{title: subItem?.caption, sidebarItemId: subItem?.id}}>
                          <div className={"list-circle"}></div>
                          {subItem?.caption}
                        </Link>
                      ))}
                    </div>
                  </div>
                </li> : !item?.hasSubList &&
                <li key={"side-" + index} className={`liIndex${index}`}>
                  {item?.icon === "websiteIcon" ?
                    <a href={item?.route} target={"_blank"} style={{color: sideData?.style?.fontColor}}>
                      {item.icon && <IconViewer icon={item.icon}/>}
                      {item?.caption}
                    </a> :
                    <Link to={item?.route} state={{title: item?.caption, sidebarItemId: item?.id}}>
                      {item.icon && <IconViewer icon={item.icon}/>}
                      {item?.caption}
                    </Link>
                  }
                </li>
            ))}
            <li onClick={logOutHandler}>
              <Link to={"/login"}>
                <IconViewer icon={"LogoutIcon"}/>
                خروج
              </Link>
            </li>
            {open &&
              <li className={"close-sidebar"} onClick={() => setOpen(false)}>
                {Close}
              </li>
            }
          </ul>
          : <></>}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default NewSideBar;